// apps/dashboard/src/lib/auth-secret-urls.ts
//
// /auth/action and /auth/verify are opened with a single-use secret in the query string
// (Firebase `oobCode`, our own `token`). Anything that records URLs must not record those.

const SECRET_PATHS = ['/auth/action', '/auth/verify'];
const SECRET_PARAM = /([?&](?:oobCode|token)=)[^&#]*/g;

/** True for the pages whose query string carries a single-use secret. */
export function isSecretBearingPath(pathname: string): boolean {
  return SECRET_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

/** Replaces the value of `oobCode` and `token` in a URL or query string. Other text is untouched. */
export function redactAuthSecrets(value: string): string {
  return value.replace(SECRET_PARAM, '$1[redacted]');
}
